import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 86 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="40 0, 80 22.5, 80 67.5, 40 90, 0 67.5, 0 22.5"
        />
        <path
          d="M 58.99 64.329 L 53.371 64.329 L 39.88 28.892 L 44.762 27 L 56.31 58.877 L 67.91 27.157 L 72.425 28.892 L 58.99 64.329 Z M 39.092 62.755 L 34.42 64.959 L 29.853 55.003 Q 28.12 51.278 25.495 49.702 A 12.53 12.53 0 0 0 19.284 48.132 A 20.59 20.59 0 0 0 18.777 48.125 L 17.99 48.125 L 17.99 64.329 L 13 64.329 L 13 27.683 Q 15.783 27.421 18.328 27.289 Q 20.873 27.157 23.761 27.157 A 21.65 21.65 0 0 1 30.265 28.021 A 10.935 10.935 0 0 1 33.865 29.887 Q 37.252 32.617 37.252 36.921 Q 37.252 40.753 34.968 43.090 A 13.377 13.377 0 0 1 29.300 46.313 A 22.467 22.467 0 0 1 28.383 46.580 Q 29.8 47.210 30.903 48.076 Q 32.005 48.941 33.029 50.385 Q 34.103 52.129 35.153 54.435 L 39.092 62.755 Z M 17.99 31.567 L 17.99 43.907 L 23.761 43.907 Q 27.541 43.907 29.902 42.227 Q 32.264 40.547 32.264 37.394 Q 32.264 34.769 30.059 33.063 A 9.169 9.169 0 0 0 24.994 31.399 A 17.635 17.635 0 0 0 23.761 31.357 Q 21.976 31.357 20.559 31.410 Q 19.141 31.463 17.99 31.567 Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);
// const IconLogo = () => (
//   <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
//   <title>Logo</title>
//   <g transform="translate(10, 5)">

//     <polygon
//       id="Shape"
//       stroke="currentColor"
//       stroke-width="5"
//       fill="none"
//       stroke-linecap="round"
//       stroke-linejoin="round"
//       points="40 0, 80 22.5, 80 67.5, 40 90, 0 67.5, 0 22.5"
//     />

//     <g transform="translate(12, 26) scale(0.7)">
//       <path d="M 65.7 53.325 L 57.675 53.325 L 38.4 2.7 L 45.375 0 L 61.875 45.525 L 78.45 0.225 L 84.9 2.7 L 65.7 53.325 Z M 37.275 51.075 L 30.6 54.225 L 24.075 39.975 Q 21.6 34.65 17.85 32.4 A 17.9 17.9 0 0 0 8.973 30.159 A 29.414 29.414 0 0 0 8.25 30.15 L 7.125 30.15 L 7.125 53.325 L 0 53.325 L 0 0.975 Q 3.975 0.6 7.612 0.412 Q 11.25 0.225 15.375 0.225 A 30.934 30.934 0 0 1 24.668 1.459 A 15.622 15.622 0 0 1 29.812 4.125 Q 34.65 8.025 34.65 14.175 Q 34.65 19.65 31.387 22.987 A 19.111 19.111 0 0 1 23.286 27.594 A 32.096 32.096 0 0 1 21.975 27.975 Q 24 28.875 25.575 30.112 Q 27.15 31.35 28.612 33.412 Q 30.075 35.475 31.575 38.775 L 37.275 51.075 Z M 7.125 6.525 L 7.125 24.15 L 15.375 24.15 Q 20.775 24.15 24.15 21.75 Q 27.525 19.35 27.525 14.85 Q 27.525 11.1 24.375 8.662 A 13.099 13.099 0 0 0 17.137 6.285 A 25.193 25.193 0 0 0 15.375 6.225 Q 12.825 6.225 10.8 6.3 Q 8.775 6.375 7.125 6.525 Z"
//         fill="currentColor"
//       />
//     </g>
//   </g>
// </svg>
// );

export default IconLogo;
